import ScrollBreakpoint from '../shared/classes/ScrollBreakpoint';
import { DOM } from '../shared/helpers/Document';

/*
 * Scrolling breakpoints 
 */
(function() {
	
	const windowScrolledClassname = 'content-scroll';
	const screenScrolledClassname = 'screen-scroll';
	const animatedScrollClassname = 'appear-on-scroll';
	const animatedScrollActiveClassname = 'appear-on-scroll-active';
	
	const body = document.body;
	const breakPoints = [
		{ 
			breakpoint: 200,
			callBack: {
				UP: (/*element*/) => {
					//document.querySelector('.site-top-bar').classList.remove('min');
					body.classList.remove(windowScrolledClassname);
				},
				
				DOWN: (/*element*/) => {
					//document.querySelector('.site-top-bar').classList.add('min');
					body.classList.add(windowScrolledClassname);
				}
			}
		},
		
		{ 
			breakpoint: 1920,
			callBack: {
				UP: (/*element*/) => {
					//document.querySelector('.site-top-bar').classList.remove('min');
					body.classList.remove(screenScrolledClassname);
				},
				
				DOWN: (/*element*/) => {
					//document.querySelector('.site-top-bar').classList.add('min');
					body.classList.add(screenScrolledClassname);
				}
			}
		},
	];
	
	const scrollBP = new ScrollBreakpoint(breakPoints);

	
	document.addEventListener('pageLoad', (evt) => {
		const doc = evt.detail.document;
		const elements = doc.querySelectorAll('.'+ animatedScrollClassname);
		scrollBP.addBreakpoint({ 
			breakpoint: elements,
			callBack: {
				DOWN: function() {
					const c = this.element.classList;
					c.add(animatedScrollActiveClassname);
					c.remove(animatedScrollClassname);
					setTimeout(() => c.remove(animatedScrollActiveClassname), 2000);
				}
			}
		});
	});
}());